package com.havn.app.features.openhouses.domain

data class OpenHouse(
    val id: String,
    val propertyId: String,
    val propertyTitle: String,
    val propertyAddress: String,
    val hostAgentId: String,
    val propertyThumbnailDataUrl: String? = null,
    val propertyPhotoDataUrls: List<String> = emptyList(),
    val title: String? = null,
    val startsAt: String,
    val endsAt: String,
    val status: OpenHouseStatus,
    val accessNotes: String? = null,
    val internalNotes: String? = null,
    val createdAt: String? = null,
    val updatedAt: String? = null,
    val stats: OpenHouseStats = OpenHouseStats(),
    val recentSignIns: List<OpenHouseVisitor> = emptyList()
) {
    val displayTitle: String
        get() = title?.takeIf { it.isNotBlank() } ?: propertyTitle
}

data class OpenHouseDraft(
    val propertyId: String,
    val title: String = "",
    val startsAt: String,
    val endsAt: String,
    val accessNotes: String = "",
    val internalNotes: String = ""
)

data class OpenHousePropertyOption(
    val id: String,
    val title: String,
    val address: String,
    val thumbnailDataUrl: String? = null,
    val photoDataUrls: List<String> = emptyList()
)

enum class OpenHouseStatus(val label: String, val databaseValue: String) {
    Scheduled("Scheduled", "scheduled"),
    Live("Live", "live"),
    Completed("Completed", "completed"),
    Cancelled("Cancelled", "cancelled");

    companion object {
        fun fromDatabase(value: String?): OpenHouseStatus = when (value) {
            "live" -> Live
            "completed" -> Completed
            "cancelled" -> Cancelled
            else -> Scheduled
        }
    }
}

data class OpenHouseStats(
    val visitorCount: Int = 0,
    val hotCount: Int = 0,
    val warmCount: Int = 0,
    val coldCount: Int = 0
)

data class OpenHouseVisitor(
    val id: String,
    val clientId: String? = null,
    val visitorId: String? = null,
    val fullName: String,
    val email: String? = null,
    val phone: String? = null,
    val temperature: LeadTemperature,
    val checkedInAt: String
)

enum class LeadTemperature(val label: String, val databaseValue: String) {
    Hot("Hot", "hot"),
    Warm("Warm", "warm"),
    Cold("Cold", "cold");

    companion object {
        fun fromDatabase(value: String?): LeadTemperature = when (value) {
            "hot" -> Hot
            "cold" -> Cold
            else -> Warm
        }
    }
}

data class KioskSession(
    val openHouseId: String,
    val code: String,
    val kioskPath: String
)

data class VisitorSignInDraft(
    val fullName: String,
    val phone: String? = null,
    val email: String? = null,
    val workingWithAgent: Boolean,
    val interest: VisitorInterest
)

enum class VisitorInterest(val label: String, val answerValue: String) {
    Buying("Buying", "buying"),
    Investing("Investing", "investing"),
    Browsing("Just browsing", "just_browsing"),
    Relocating("Relocating", "relocating")
}
